import { graphql } from "~/lib/graphql";

export const singleImageFragment = graphql(`
  fragment singleImageFragment on ImageSingleRecord {
    __typename
    id
    doNotCropTheImage
    fitClip
    image {
      id
      title
      author
      copyright
      blurUpThumb
      height
      width
      url
      alt
      focalPoint {
        x
        y
      }
    }
  }
`);
